import { PayloadAction } from '@reduxjs/toolkit';
import { all, call, fork, put, select, takeEvery } from 'redux-saga/effects';
import { dialogueRequest, verificationRequest } from '../../../services/product';
import { DialogueRegisterState, IVerificationRegister, registerVerification } from 'core/slices/register';
import { selectVerificationRequest } from 'core/selectors/product/verificationRequest';
import { IVerificationRequestDAO, VerificationRequestType, VerificationType } from 'types/domain/verification';
import { selectToken } from 'core/selectors/product/token';
import { ISessionReducer, IToken, Mode } from 'core/slices/session';
import { authRequest } from 'core/services/authentication';
import { AnyAsyncThunk, FulfilledActionFromAsyncThunk } from '@reduxjs/toolkit/dist/matchers';
import { selectSession } from 'core/selectors/product/session';
import { selectSessionMode } from 'core/selectors/admin/sessionMode';
import { CourseNodeStatus, ICourseNodeDAO } from 'types/domain/course';
import { selectCourseNode } from 'core/selectors/admin/courseNode';

function* verificationRegisterSaga(action: PayloadAction<IVerificationRegister>) {
  const verificationRequestDAO: IVerificationRequestDAO = yield select(state =>
    selectVerificationRequest(state, action.payload.verificationRequestId),
  );
  const mode: Mode = yield select(selectSessionMode);
  const token: IToken = yield select(selectToken);
  const session: ISessionReducer = yield select(selectSession);
  //auto register verifications with no action
  if (
    mode === Mode.PREVIEW ||
    !verificationRequestDAO ||
    verificationRequestDAO.type === VerificationRequestType.REQUEST
  )
    return;

  yield put(
    yield call(verificationRequest, {
      verificationRequestId: [VerificationRequestType.REQUEST].includes(verificationRequestDAO.type)
        ? verificationRequestDAO.id
        : null,
      courseProgressId: token.courseProgressId,
      sessionId: session.session.id,
      courseNodeToken: verificationRequestDAO.courseNodeToken,
      token: token.token,
      tokenCreated: token.created,
      auto: false, //should not proceed,
    }),
  );
}

function* authRequestSaga(action: FulfilledActionFromAsyncThunk<AnyAsyncThunk>) {
  const courseNodeDAO: ICourseNodeDAO = yield select(state => selectCourseNode(state, action.meta.arg.courseNodeId));
  const session: ISessionReducer = yield select(selectSession);
  const token: IToken = yield select(selectToken);
  if (session.mode === Mode.LEARNING && courseNodeDAO && courseNodeDAO.status === CourseNodeStatus.PRIVATE)
    yield put(
      yield call(dialogueRequest, {
        token: token.token,
        courseNodeId: courseNodeDAO.id,
        courseProgressId: token.courseProgressId,
        state: DialogueRegisterState.SUBMITTED,
      }),
    );
}

function* verificationRegister() {
  yield takeEvery(registerVerification, verificationRegisterSaga);
}

function* watchAuthRequest() {
  yield takeEvery(authRequest.fulfilled, authRequestSaga);
}

export function* verificationSaga() {
  yield all([fork(verificationRegister), fork(watchAuthRequest)]);
}
